export const DEFAULT_SURFACE_ID = 'obf-DynamicWebSurfaces'
